import * as customIcons from './custom-icons';
import { materialSymbolIcons } from './material-symbols';
import * as muiIcons from './mui-icons';
const icons = { ...customIcons, ...materialSymbolIcons, ...muiIcons };
export * from './mui-icons';
export * from './custom-icons';
export * from './material-symbols';
export default icons;
export function getIcon(icon) {
    return icons[icon];
}
